// extracted by mini-css-extract-plugin
export default {"ResponsiveWrapper":"ResponsiveWrapper_ResponsiveWrapper__WBMyC","Loading":"ResponsiveWrapper_Loading__4OXnk"};